import { useMutation } from '@tanstack/vue-query';

import {
  acceptAgreement,
  login,
  loginWithAccount,
  recoverPassword,
  sendConfirmationEmail,
  updateProfileEmail
} from '@/services/auth';

export function useLoginMutation(options = {}) {
  return useMutation({
    mutationFn: ({ login: loginValue, password }) => login({ login: loginValue, password }),
    ...options
  });
}

export function useLoginWithAccountMutation(options = {}) {
  return useMutation({
    mutationFn: ({ accountProfile }) => loginWithAccount(accountProfile),
    ...options
  });
}

export function useRecoverPasswordMutation(options = {}) {
  return useMutation({
    mutationFn: ({ loginValue, language }) => recoverPassword(loginValue, language),
    ...options
  });
}

export function useSendConfirmationEmailMutation(options = {}) {
  return useMutation({
    mutationFn: ({ email }) => sendConfirmationEmail(email),
    ...options
  });
}

export function useUpdateProfileEmailMutation(options = {}) {
  return useMutation({
    mutationFn: ({ id, email }) => updateProfileEmail(id, email),
    ...options
  });
}

export function useAcceptAgreementMutation(options = {}) {
  return useMutation({
    mutationFn: ({ userId }) => acceptAgreement(userId),
    ...options
  });
}
